// types
import { AuthProps, AuthActionProps } from 'types/auth';

// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';

// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isValidEmail: false,
  isInitialized: false,
  customer: undefined,
  orders: [],
  rental_devices: [],
  cloud_devices: [],
  credit_cards: [],
  certificates: [],
  bank_account: undefined
};

// ==============================|| AUTH REDUCER ||============================== //

const authReducer = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case LOGIN: {
      const { customer, orders, rental_devices, cloud_devices, credit_cards, certificates, bank_account, remise_token, isValidEmail } =
        action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isValidEmail,
        isInitialized: true,
        customer,
        orders,
        rental_devices,
        cloud_devices,
        credit_cards,
        certificates,
        bank_account,
        remise_token
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        customer: undefined,
        orders: [],
        rental_devices: [],
        cloud_devices: [],
        credit_cards: [],
        certificates: [],
        bank_account: undefined,
        remise_token: undefined
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default authReducer;
